/*
 * @file cn.js
 * @author liushengxgi
 * @date 2020-09-03 10:52:17
 * ----
 * @last Modified by liushengxgi
 * @last Modified time 2020-09-03 11:00:49
 */

export default {
    publisherSite: {
        detail: '详情',
        operator: '操作人',
        operate: '操作',
        reset: '重置',
        submit: '提交',
        search: '查询',
        total: '共',
        publisherSite: 'Publisher Site',
        mediaGroup: '媒体组',
        whitelistCompany: '加白公司',
        whitelistAccount: '加白账户',
        whitelistCampaign: '加白计划',
        addWhitelist: '添加白名单',
        addWhitelistRule: '添加白名单规则',
        resetBtn: '重置',
        atLeastOneDimension: '以下三个维度至少填写一项',
        noticeDesc: '说明：加白公司、加白账户、加白计划为"或"的关系。',
        noticeItem1: '选择"加白公司A" → 公司A下的所有账户和计划自动白名单',
        noticeItem2: '选择"加白账户B" → 账户B下的所有计划自动白名单',
        noticeItem3: '选择"加白计划C" → 仅计划C白名单',
        noticeItem4: '三者可同时选择，满足任意条件即生效。',
        mediaGroupPlaceholder2: '选填，方便后续查询',
        companyInputPlaceholder2: '批量输入公司名称，请以";;"区分.',
        accountInputPlaceholder2: '批量输入请账户id，以";;"区分.',
        campaignInputPlaceholder2: '批量输入campaign ID请以";;"区分.',
        editRule: '编辑规则',
        viewDetail: '查看详情',
        deleteRule: '删除规则',
        download: '下载',
        searchSite: '搜索 Publisher Site',
        searchMediaGroup: '搜索媒体组',
        inputSite: '输入site',
        inputMediaGroup: '输入规则名称',
        tipTitle: '注意:',
        tipContent1: '"加白公司"、"加白账户"、"加白计划"三列是"或"的关系，不是"且"的关系。',
        tipContent2: '示例：',
        tipContent3: '• 如果"加白公司"列显示"公司A"，"加白账户"列显示"账户B"',
        tipContent4: '则说明：公司A下的所有账户和计划 + 账户B下的所有计划，都可以上单到该站点。',
        tipContent41: '而不是：必须同时属于公司A且属于账户B才能上单。',
        tipContent5: '添加site过滤按照精准匹配原则，如有"weather.com"和"www.weather.com"需要匹配，请同时输入"weather.com"和"www.weather.com"。',
        tipText: '注意："加白公司"、"加白账户"、"加白计划"三列是"或"的关系，不是"且"的关系。示例：如果"加白公司"列显示"公司A"，"加白账户"列显示"账户B"，则说明：公司A下的所有账户和计划 + 账户B下的所有计划，都可以上单到该站点。而不是：必须同时属于公司A且属于账户B才能上单。',
        deleteConfirmText: '点击删除规则，意味着该行加白规则去除。确认删除吗？',
        deleteItemConfirmText: '确认删除该加白项吗？',
        deleteSuccess: '删除成功',
        siteInputPlaceholder: '请输入完整域名，域名只支持进行精准匹配。批量输入时请以“;;"区分，如“baidu.com;;www.baidu.com”',
        siteTip: 'Publisher Site仅支持精准匹配，但同时会命中"www"前缀的站点。例如输入"baidu.com"，会同时命中"baidu.com"和"www.baidu.com"',
        siteRequired: '请输入Publisher Site',
        siteFormatError: '请输入至少含一个"."的site',
        mediaGroupPlaceholder: '请输入媒体组名称（非必填，方便备注查询）',
        formNotice: '说明：加白公司、加白账户、加白计划为"或"的关系。选择"加白公司A" → 公司A下的所有账户和计划自动白名单；选择"加白账户B" → 账户B下的所有计划自动白名单；选择"加白计划C" → 仅计划C白名单。三者可同时选择，满足任意条件即生效。',
        companyInputPlaceholder: '请输入公司名称，支持批量输入，以;;区分',
        verifyBtn: '查询验证',
        companyVerifyTip: '请查看公司名是否输入完整、正确。公司名称输入错误的，无法提交成功。',
        pleaseInputCompany: '请输入公司名称',
        someCompanyNotVerified: '以下公司未验证通过：{names}',
        someAccountNotVerified: '以下账户未验证通过：{names}',
        someCampaignNotVerified: '以下计划未验证通过：{names}',
        pleaseInputAccount: '请输入账户ID',
        pleaseInputCampaign: '请输入Campaign ID',
        verifySuccess: '验证成功',
        hasUnverifiedItems: '存在未验证通过的项，请检查后重试',
        submitFailed: '提交失败，请重试',
        blacklistConflict: '请确认添加公司或账户未在本批站点进行过加黑过滤设置',
        validationFailed: '请查看公司名/账户ID/计划ID是否输入完整、正确。输入错误的，无法提交成功',
        blacklistWarning: '请确认添加公司或账户未在本批站点进行过加黑过滤设置',
        notVerified: '(未验证)',
        hasUnverifiedCompany: '存在未验证通过的公司，请检查公司名称是否正确',
        accountInputPlaceholder: '请输入账户ID，支持批量输入，以;;区分',
        accountTip: '请输入账户ID，以;;分隔',
        campaignInputPlaceholder: '请输入Campaign ID，支持批量输入，以;;区分',
        campaignTip: '请输入Campaign ID，以;;分隔',
        atLeastOneRequired: '加白公司、加白账户、加白计划至少填写一项',
        addSuccess: '添加成功',
        updateSuccess: '更新成功',
        dimension: '维度',
        name: '名称',
        addTime: '加白时间',
        company: '公司',
        account: '账户',
        campaign: '计划',
        noMatchFound: '查询不到匹配内容'
    },
    menuData: {
        publisherSiteTitle: '配置publisher白名单规则',
        dashboardTitle: 'ダッシュボード',
        editorialTitle: '編集ツール',
        domainTitle: 'ドメインブロック',
        authorizeTitle: '権限管理',
        roleTitle: '役割管理',
        accountTitle: 'アカウントリスト',
        userTitle: 'ユーザーリスト',
        managementTitle: 'メディアリスト',
        audienceTitle: 'オーディエンスターゲティング構成',
        sensitiveTagTitle: '危ない広告タグリスト',
        sensitiveCfgTitle: '危ない広告タグを設定する',
        adxTitle: 'ssp管理',
        discoveryBWconfigTitle: 'D_SSP level 黑白名單',
        mediaBWconfigTitle: 'Account-level media blacklist/whitelist',
        mediaBWconfig: 'Account-level media blacklist/whitelist',
        mediaSellerIdConfigTitle: 'Account-level Seller ID blacklist/whitelist',
        cruiseRejectBlackListTitle: 'Cruise Rejection',
        assetSiteFilter: '素材四元素publisher site流量过滤',
        assetSiteFilterTitle: '素材四元素publisher site流量过滤',
        auditRejectOnceTitle: 'Single Rejection',
        creativeRiskTitle: 'Image Creative Risk Control',
        xandrAuditManagment: 'Brand Name Review Management',
        xandrAuditManagmentTitle: 'Brand Name Review Management',
        accountSiteFilter: '账户类型、公司账户屏蔽',
        accountSiteFilterTitle: '账户类型、公司账户屏蔽',
        sspReportTitle: 'SSP Report'
    },
    button: {
        addAccount: 'アカウント追加',
        addUser: 'ユーザー追加',
        addRole: '役割追加',
        status: 'ステータス',
        del: '削除',
        bwList: 'Black and white list'
    },
    sspReport: {
        addDaily: 'Add daily report',
        addDailyReportTitle: 'New daily report configuration',
        editDailyReportTitle: '日次レポートを編集',
        deleteConfirm: '削除後、レポートは送信されず、復元できません。',
        deleteSuccess: '削除しました',
        updateSuccess: '保存しました',
        loadDetailFailed: '設定の取得に失敗しました',
        colIndex: '#',
        emailName: 'Email name',
        emailNamePh: 'Enter email name',
        emailNameMaxLen: 'Email name cannot exceed 200 characters',
        emailNameNoEmoji: 'Email name cannot contain emoji',
        emailNameDuplicate: 'This name is already in use. Please use another.',
        dataSource: 'Data source',
        dataSourcePh: 'Select SSP',
        dataSourcePhChannel: 'Select Channel',
        dataSourceTypeSsp: 'SSP',
        dataSourceTypeChannel: 'Channel',
        reportType: 'Report type',
        typeFilterAll: 'All',
        setColumns: 'Columns',
        dimSection: 'Dimensions',
        metricSection: 'Metrics',
        selectedColumnsTitle: 'Selected (drag to reorder)',
        resetColumns: 'Reset',
        dimDate: 'Date (MTD by day)',
        dimIpCountry: 'Country',
        dimIsApp2web: 'Web or APP',
        dimTrafficType: 'Traffic Type',
        dimDevice: 'Device',
        metricImp: 'Impressions',
        metricImpCost: 'Traffic cost',
        metricCpm: 'CPM',
        metricClicks: 'clicks',
        metricCost: 'Cost',
        metricImpressions: 'Impressions',
        columnMetricRequired: 'Select at least one metric',
        recipientRequired: 'Enter at least one recipient email',
        recipientPh: 'Multiple emails, separated by commas',
        sspId: 'SSP ID',
        dimension: 'Dimension',
        metrics: 'Metrics',
        reportTimezone: 'Report timezone',
        sendTime: 'Send time',
        recipient: 'Recipients',
        createdAt: 'Created at',
        operate: 'Operate',
        dimDateShort: 'Date',
        timezonePh: 'Select timezone',
        sendTimePh: 'Select send time',
        createSuccess: 'Created successfully',
        emailInvalid: 'Invalid email: {email}',
        collapsePanel: 'Collapse'
    },
    dashboard: {
        bwType: 'Blacklist & Whitelist Type',
        mediaSearchAcc: 'アカウントでユーザーを検索',
        rpm: 'RPM',
        vrpm: 'vRPM',
        totalRevenue: 'Total Revenue',
        matchedRequest: 'Matched Ad Request',
        returnAds: 'Return Ads',
        viewsWithAds: 'Views with Ads',
        clicks: 'Ad Clicks',
        withAds: '% with Ads',
        withVisibility: '% with Visibility',
        vctr: 'vCTR',
        rendersWithAds: 'Renders With Ads',
        winRate: 'Win Rate',
        avgCPC: 'Avg CPC',
        accountName: 'アカウント名',
        // Dimension
        dimensionDate: '日付',
        dimensionAccount: 'アカウント',
        dimensionSSP: 'SSP',
        dimensionSite: 'Site',
        payin: '支払い'
    },
    editorial: {
        domain: {
            searchPlaceholder: '広告ドメイン/アカウント名を検索',
            remove: 'リストから削除する',
            block: 'ブロッキングドメインを追加'
        }
    },
    permission: {},
    management: {
        autoAuditTip: '一旦手动重新送审，会同时送审该Brand Name的banner和native流量，请检查两者是否均为拒审，如其中一个流量渠道已通过，建议不要轻易重新送审',
        autoAuditSecondTip: '一旦手动重新送审，会同时送审该Brand Name的banner和native流量，目前该Brand Name的banner/native流量已经过审，请确认是否需要重新送审',
        rejectAutoAudit: 'Rejected for Review and Under Review of Automatically Resubmitted',
        noLimit: 'All',
        yes: 'Yes',
        no: 'No',
        illegalCharacter1: 'The use of Chinese semicolon/Chinese comma/English semicolon separation is not supported. Please use English comma, to separate ssp.',
        illegalCharacter2: 'The use of Chinese semicolon/Chinese comma/English semicolon separation is not supported. Please use English comma, to separate campaign id.',
        illegalCharacter3: 'The use of Chinese semicolon/Chinese comma/English semicolon separation is not supported. Please use English comma, to separate account id.',
        illegalCharacter4: 'The use of Chinese semicolon/Chinese comma/English comma separation is not supported. Please use English semicolon; to separate account id',
        illegalCharacter5: 'The use of Chinese semicolon/Chinese comma/English comma separation is not supported. Please use English semicolon; to separate Seller ID.',
        setWhite: 'Whitelist Setting',
        meidaWhiteList: 'Campaign Place or Orders in Batches',
        accountConfig: 'Account Place or Orders in Batches',
        sspTip1: ' is broad reach SSP and the operation is not supported.',
        sspTip2: ' is the SSP of D platform and the operation is not supported.',
        sspTip3: 'Parameter Error',
        actionDetails: 'Action Details',
        xandrAsset: 'Asset',
        detailTip: 'Detail',
        operate: 'Operate',
        reAuditTip: 'Manually Resubmit for Review',
        automaticResubmissionSetTitle: 'Automatic Resubmission Settings',
        reAssetTip: 'Resubmit for Review',
        reAssetIcon: 'When entering LP and clicking search, all unarchived assets using this Lp can be displayed from the drop-down list in the resubmit asset below.',
        tokenBlockDetail: 'Seller ID Token Block Detail',
        tokenBlockDetailTip: 'View Token Block Detail',
        sellerIdText: 'The brand name has been blocked by some seller ID token in the media, click the button on the right side to check the detail',
        brandNameLanguageTip: 'Due to inconsistencies between the submission language and the media language, this brand name can\'t acquire msn traffic.',
        pendingReview: 'Pending Review',
        underReview: 'Under Review',
        reject: 'Reject',
        pass: 'Pass',
        auditFailure: 'Audit failure',
        reviewExpired: 'reviewExpired',
        brandNameReviewManagement: 'Brand Name Review Management',
        autoResubmissionSetTitle: 'Automatic Resubmission Settings',
        autoAuditAccountStatus: 'Automatically Resubmit Status',
        isSeller: 'Resubmission Condition Include Seller ID 280 Rejection',
        isLanguageDiff: 'Resubmission Condition Include Language Inconsistency',
        autoAuditAccountNum: 'Number of Automatic Re-submissions for Review',
        assetConditionSettings: 'Automatically Resubmit Asset Condition Settings',
        accountRange: 'Range of Account',
        campaignRange: 'Range of Campaign',
        assetRange: 'Asset Condition',
        all: 'All',
        oneDayTop: 'Top asset of this brand name at -1 day',
        anyAll: 'Any one of all',
        autoStatusOpt: 'Status：on/off；Number of Automatic Resubmissions：3；Range of Account：All；Range of Campaign：All；Asset Condition：Top asset of this brand name at -1 day',
        autoStatusTip: 'It is enabled by default. If it is closed manually, it will stop automatically resubmitting for review.',
        isSellerTip: 'The automatic resubmission condition defaults to rejection status, which does not include rejection status by seller ID 280. If you need to include this status, please select "Yes"',
        isLanguageDiffTip: 'The automatic resubmission condition does not include language inconsistency status by default. If you need to include this status, please select "Yes"',
        autoResubmissionNumTip: 'The number of times is a re-accumulation system. If you switch from 3 times to 5 times, the times will be recalculated.',
        accountAangeTip: 'The account displayed in the drop-down is the account to which the material corresponding to the Brand Name belongs.',
        campaignAangeTip: 'The Campaign displayed in the drop-down is the Campaign to which the material corresponding to the Brand Name belongs. If a specific account is selected in the above account range, it is the Campaign under the selected account.',
        assetAangeTip: 'The default is to submit for review based on the Top Asset income of the Asset corresponding to the Brand Name in the past day, excluding Assets that have been submitted for review and Assets that have been archived.',
        tokenBlock: 'Token Block',
        notTokenBlock: 'Not token block',
        sellerReason: 'Reason',
        reAsset: 'Resubmit Asset',
        xanderBrandName: 'Brand Name',
        auditStatus: 'Audit Status',
        xanderReason: 'Reason',
        reviewTime: 'Review Time',
        submissionTime: 'Submission Time',
        reviewLang: 'Language',
        typeSelect: 'Type',
        platform: 'Platform',
        languageUnequal: 'Inconsistent Submission Language',
        mediaLanguage: 'Media Language',
        type: 'Type',
        asset: 'Asset',
        lp: 'LP',
        searchLp: 'Enter LP to search Asset',
         addCreativeConfig: 'There are some creatives under this account that have the same dimension configuration, do they need to be overwritten and deleted?',
         creativeTip: 'When selecting account dimension control, you can choose summary control and decentralized  control; summary control means that the sum of accounts does not exceed the set upper limit; ecentralized control means that all account controls are applied to all creative id under it.',
        updateCreative: 'The {num} creatives under the account already have configurations of the same dimension, do you want to update?',
        deleteCreative: 'There are {num} creatives under this account that have been configured or are controlled by other accounts, do they need to be overwritten and deleted?',
        controlMethod: 'Control Method',
        sourceOfControl: 'Source of Control',
        summaryControl: 'summary control',
        decentralizedControl: 'decentralized control',
        itself: 'itself',
        creativePlaceholder: 'please use commas to separate',
        campaginSearch: 'Campaign ID',
        companyLevel: 'Company Level',
        accountLevel: 'Account Level',
        deleteDimension: 'After deletion, the condition restriction for this dimension will become invalid. Are you sure to delete?',
        companyName: 'Company Name',
        accountName: 'Account Name',
        accountId: 'Account ID',
        campaginId: 'Campaign ID',
        dimension: 'Dimension',
        audienceAdd: 'オーディエンスターゲティングを追加する',
        sensitiveTagAdd: '危ない系広告タグを追加する',
        sensitiveCfgAdd: '危ない広告タグを追加する',
        // adx
        rejectedSources: 'Rejected Sources',
        modifyAdx: 'adxを変更する',
        addWhiteList: '一括操作のホワイトリスト',
        setWhiteForD: 'Discovery DSP 媒体白名单配置',
        setDisplaySsp: 'Display SSP自动上单配置',
        addAdx: 'sspを追加する',
        adxSspId: 'sspid',
        adxSspName: 'ssp name',
        adxToken: 'token',
        adxHMedia: '高度なメディアかどうか',
        adxIp: 'クライアントIPを使用するかどうか',
        adxGEOEdge: 'GEO Edge',
        adxAddSuccess: '正常に作成されました',
        adxModifySuccess: '正常に作成されました',
        timezone: 'タイムゾーン',
        ssp: 'ssp',
        operateType: 'operateType',
        campaginName: 'campaginName',
        reason: 'Reason',
        creativeIdMsg: 'After deletion, no new rejection will be performed, and the assets that have been rejected will remain in the "Rejected" status.',
        rejectMsg: 'After termination, no new rejection will be performed, and the assets that have been rejected will remain in the "Rejected" status.',
        searchSpend: 'Search Spend',
        mediaRequire: 'media requirement',
        required: '{name} is required',
        dailyCost: 'Limit of Daily Spend',
        dailyImp: 'Limit of Daily Imp',
        assetImageMsg: 'After deletion, the conditional restrictions on the creative id will be invalid. Are you sure to delete the setting of this creative id?',
        dailyCostTip: 'The daily spend is the sum of the selected dimension consumption under the conditions set by the EST time zone. When the daily spend or imp any upper limit is reached, the corresponding traffic cannot be recalled.',
        dailyImpTip: 'The daily imp is the sum of the selected dimension consumption under the conditions set by the EST time zone. When the daily spend or imp any upper limit is reached, the corresponding traffic cannot be recalled.',
        countryTip: 'When multiple country are selected, they will be split for statistics, and the relationship between them and the selection in the dimension is N*N. For example, if you select the United States and the United Kingdom for the country, and account 1 is selected for the dimension, two pieces of data will appear on the page after submission.',
        hasCreativeId: 'The creative id already exists, please operate from the Edit entry in the action column',
        hasSppGroup: 'This SSP combination already exists, please edit it in the original combination',
        sitePlaceHolder: 'please use commas to separate',
        dailyCostValid: 'The daily cost must have no more than 2 decimal positions',
        element: 'Element',
        country: 'Country',
        language: 'Language',
        content: 'Content',
        rejectedReason: 'Rejection Reason',
        brandName: 'Brand name',
        keyword: 'Keyword',
        domainName: 'Domain',
        operator: 'Operator',
        reviewer: 'Reviewer',
        rejectAddSuccess: 'Add successfully',
        createTime: 'Create Time',
        completionTime: 'Completion Time',
        operatingTime: 'Operating Time',
        status: 'Status',
        doing: 'In execution, Click to terminate',
        stop: 'Terminated',
        done: 'Completed',
        download: 'Download',
        detail: 'detail',
        success: 'success',
        downloadToReject: 'Please download the details for a second confirmation of rejection',
        noDownload: 'Please download the details before confirming your rejection',
        isConfrimReject: 'Are you sure you want to reject them?',
        contentTitle: `【Example of Creative ID dimension content】
        URL：https://resource.popin.cc/ML/c5d69c5de0bbac6490bda9d103btestd.png
        Input：c5d69c5de0bbac6490bda9d103btestd
        （Between https://resource.popin.cc/ML/ and .png）
        【Example of Brand Name dimension content】
        Brand Name：Test Brand
        Input：Test Brand
        【Example of keyword dimension content】
        Headline：Be careful if you have these illegal words around you!
        「Case 1」Input：illegal words
        Match：Be careful if you have these illegal words around you!;;These illegal words will affect your life
        「Case 2」Input：Be careful if you have these illegal words around you!
        Match：Be careful if you have these illegal words around you!
        【Example of Domain dimension content】
        Landing Page：https://test.cloudfront.net/
        Input：test.cloudfront.net
        （Between https:// and /）
        `,
        rejectTitle: '* Operation records before April 17, 2023, are displayed as Baidu Rejected.'
    },
    rejectCountry: {
        CA:	'Canada',
        JP:	'Japan',
        US: 'USA',
        CH:	'Switzerland',
        PT:	'Portugal',
        BE:	'Belgium',
        MX:	'Mexico',
        BS:	'Brasil',
        HU:	'Hungary',
        DK:	'Denmark',
        NO:	'Norway',
        CZ:	'Czechia',
        SE:	'Sweden',
        PL:	'Poland',
        NL:	'Netherlands',
        ES:	'Spain',
        AT: 'Austria',
        IT:	'Italy',
        GB:	'United Kingdom',
        AU: 'Australia',
        KR: 'Korea',
        TW:	'Taiwan',
        ID:	'Indonesia',
        SG:	'Singapore',
        MY: 'Malaysia',
        TH:	'Thailand',
        HK:	'Hong Kong',
        DE:	'Germany',
        FR:	'France'
    },
    rejectLanguage: {
        en: 'English',
        de: 'German',
        pt: 'Portuguese',
        fr: 'French',
        es: 'Spanish',
        hu: 'Hungarian',
        da: 'Danish',
        nb: 'Norwegian',
        cs: 'Czech',
        sv: 'Swedish',
        pl: 'Polish',
        nl: 'Dutch',
        it: 'Italian'
    },
    rejectReason: {
        celebrity: 'Rejected due to non-compliant celebrity headline',
        Cryptocurrency: 'Rejected due to non-compliant Cryptocurrency headline',
        suffering: 'Rejected due to non-compliant suffering/violence headline',
        sensitive: 'Rejected due to non-compliant sensitive headline'
    },
    siteList: {
        listRuleTip:
            '当前列表仅展示已配置过广告审核 / 机器脚本标签的站点，未配置标签的站点请点击右上角【新增站点】按钮进行配置',
        deleteConfirmText: '删除后该站点的广告审核标签和机器脚本标签全量解绑。<br/>删除操作不可取消，请点击确认按钮以继续。',
        deleteSuccess: '删除成功',
        logDialogTitle: '操作日志'
    },
    creativeRisk: {
        constantSpeedControl: 'Account Level (Pacing Control)',
        constantSpeedControlTip: 'Please note: Account Level and Account Level (Pacing Control) will both be active simultaneously. In extreme cases, the daily spend limit set at the Account Level may be reached first, leading to strong user perception. It is recommended to check the Account Level list after configuration. If the Pacing Control Account has an Account Level configuration, it is advisable to delete the Account Level configuration to avoid extreme situations.',
        dailyCostTip: 'The daily spending is the total consumption of the selected dimensions under the conditions set for the EST time zone. Once the daily spending limit is reached, the campaigns under the account cannot be recalled. The limit will be proportionally allocated based on the daily budget of the campaigns under the account to achieve an even control effect. The specific formula is: Each active campaign’s allocated limit = daily spend limit * (campaign daily budget / sum of all active campaign daily budgets).',
        addBtn: 'Add Pacing Control',
        dailyCostCannotBeZero: 'The daily spending limit cannot be 0.',
        dailyCostMustBeNumber: 'The daily spending limit must be a number.',
        accountSpeedControlTipText: 'Please note: Add, delete, and edit operations at the Account Level (Pacing Control) may take up to an hour to take effect and will not be immediate.'
    }

};
